import {useState} from "react";
import {CommuneFormPopup} from "../form/CommuneFormPopup";
import {CommuneTable} from "../table/CommuneTable";

import {Button} from '@komune-io/g2-components'
import {Row} from "@komune-io/g2-layout";
import {
  Commune,
  CommuneCreateCommand,
  CommuneDeleteCommand,
  CommuneUpdateCommand
} from "../../model/Commune";
import {
  useCommuneAllQuery,
  useCommuneCreateMutation, useCommuneDeleteMutation,
  useCommuneUpdateMutation
} from "../../api/CommuneApi";
import {PlatformSubSection} from "@tracabois/template";

interface CommuneSectionProps {
  title: string
}

export const CommuneSection = (props: CommuneSectionProps) => {
  const {title} = props
  const [selectedItem, setSelectedItem] = useState<Partial<Commune> | undefined>(undefined)
  const communePageQuery = useCommuneAllQuery();
  const [createCommune] = useCommuneCreateMutation()
  const [updateCommune] = useCommuneUpdateMutation()
  const [deleteCommune] = useCommuneDeleteMutation()

  const closePopup = () => {
    setSelectedItem(undefined)
  }

  const handleCreate = async (item: CommuneCreateCommand) => {
    await createCommune(item)
    closePopup()
    communePageQuery.refetch()
    return true
  }
  const handleUpdate = async (item: CommuneUpdateCommand) => {
    await updateCommune(item)
    closePopup()
    communePageQuery.refetch()
    return true
  }
  const handleDelete = async (item: CommuneDeleteCommand) => {
    await deleteCommune(item)
    closePopup()
    communePageQuery.refetch()
    return true
  }
  const clickHandler = (row: Row<Commune>) => {
    setSelectedItem(row.original)
  }
  const actions = (<Button color="primary"
                           onClick={() => setSelectedItem({})}>Ajouter une commune</Button>)
  return (
    <PlatformSubSection title={title}>
      <CommuneTable page={communePageQuery.data}
                    onPageQueryChange={communePageQuery.setPageQuery}
                    onRowClicked={clickHandler}
                    isLoading={communePageQuery.isLoading}
                    actions={actions}
      />
      <CommuneFormPopup
        open={!!selectedItem} item={selectedItem || {}}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
        onCancel={closePopup}
      />
    </PlatformSubSection>
  )
}
